// extracted by mini-css-extract-plugin
export default {"container":"tag-list_container__VEH79","add_btn":"tag-list_add_btn__mqC-V"};